module.exports = __webpack_public_path__ + "images/stickers/pete-award@2x.6c96abfe6191da38f506.png";